import { render, staticRenderFns } from "./sys-sensitive-index.vue?vue&type=template&id=91965ef2&scoped=true"
import script from "./sys-sensitive-index.vue?vue&type=script&lang=js"
export * from "./sys-sensitive-index.vue?vue&type=script&lang=js"
import style0 from "./sys-sensitive-index.vue?vue&type=style&index=0&id=91965ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91965ef2",
  null
  
)

export default component.exports